"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BreakpointsProvider_1 = require("@cvent/carina/components/Breakpoints/BreakpointsProvider");
function useRowMargins() {
    var _a = (0, BreakpointsProvider_1.useBreakpoints)(), isDefaultSize = _a.isDefaultSize, isS = _a.isS, isM = _a.isM;
    if (isDefaultSize || isS) {
        return 8;
    }
    if (isM) {
        return 24;
    }
    return 0;
}
exports.default = useRowMargins;
//# sourceMappingURL=useRowMargins.js.map